import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useProducts } from '../../../context/ProductContext';
import ContactSection from '../../../components/ContactSectionPage/Index';
import { urlFor } from '../../../components/sanityProject/imageUrl';
import useTitle from '../../../useTitle';
import './Styles.css';
import NotFound from '../../NotFoundPage/Index';

// Convert slug to display name: "tie-clips" -> "Tie Clips"
const slugToTitle = (slug) =>
  slug.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

// Convert title to URL slug: "Tie Clips" -> "tie-clips"
const titleToSlug = (title) =>
  title?.toLowerCase().replace(/\s+/g, '-');

const CategoryPage = () => {
  const { categoryName } = useParams(); // Get the category slug from the URL
  const { products, loading } = useProducts(); // Get products from context

  const displayName = slugToTitle(categoryName); 
  useTitle(displayName); // Set the title of the page dynamically based on the category

  // Loading state
  if (loading) return <div className='braceletsPageSectionContainer'><p>Loading...</p></div>;

  // Filter products by the slug or category title
  const filteredProducts = products
    .filter(product => {
      const slug = product.category?.slug?.current
        ? product.category.slug.current
        : titleToSlug(product.category?.title);

      return slug.toLowerCase() === categoryName.toLowerCase();
    })
    // Sort alphabetically by title
    .sort((a, b) => a.title.localeCompare(b.title));

  // If no products match the category, show a 404 message
  if (filteredProducts.length === 0) {
    return (
      <NotFound />
    );
  }

  // If products exist, render the products
  return (
    <>
      <div className='braceletsPageSectionContainer'>
        <div className='braceletsTitlePageSection'>
          <h1 className='braceletsTitle'>{displayName}</h1>
        </div>

        <div className='productSectionContainer'>
          {filteredProducts.map(product => (
            <Link to={`/product/${product.slug.current}`} key={product._id}>
              <div className='productCategory'>
                <div className='productPhotoContainer'>
                  <img
                    src={urlFor(product.mainImage).url()}
                    alt={product.title}
                    className='productImage'
                  />
                </div>
                <div className='productTitleContainer'>
                  <h2 className='productTitle'>{product.title}</h2>
                </div>
                <div className='productPriceContainer'>
                  <p className='productPrice'>€ {product.price.toFixed(2)}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <ContactSection />
    </>
  );
};

export default CategoryPage;